import React, { CSSProperties, FC } from 'react';
import linkDecorator from './linkDecorator';
import Linkify from 'react-linkify';
import { decodeHTMLEntities } from 'utilities/formatString';

interface IContentProps {
  content: string;
  style?: CSSProperties;
  className?: string;
}

/*
    This component is created only to check if the content has emojis.
    If it has it, it converts the content into HTML, otherwise it simply renders
*/

const Content: FC<IContentProps> = ({ content = '', style, className }) => {
  const decodedText = decodeHTMLEntities(content);

  const formatBoldText = (text: string) => {
    // Split by single or double asterisks patterns
    return text.split(/(\*[^\s].*?[^\s]\*|\*\*[^\s].*?[^\s]\*\*)/).map((part, index) => {
      // Check for single asterisk pattern
      if (part.startsWith('*') && part.endsWith('*') && !part.startsWith('**')) {
        // Remove single asterisks and wrap in strong tag
        return <strong key={index}>{part.slice(1, -1)}</strong>;
      }
      return part;
    });
  };

  return (
    <Linkify componentDecorator={linkDecorator}>
      <div className={className} style={style}>
        {formatBoldText(decodedText)}
      </div>
    </Linkify>
  );
};

export default Content;
